'use es6';

import { CROSS_TAB } from 'reporting-visualizations/constants/visualizationTypes';
import { CrossTabVisualization } from 'reporting-visualizations/visualizations/crossTab/crossTabRecords';
import { SUBTOTAL_ALIAS_PREFIX, toSubtotalAlias, toTotalAlias } from '../../modify/totals/totals';
import { getReportColumnsEncodings, getReportRowsEncodings, getReportValuesEncodings } from '../../utils/report-utils';
import { toVisualizationOrder } from '../../modify/sorts/report-sort-utils';
import { getPrimaryDataset } from 'reporting-data/v2/dataset/datasetGetters';
export const mapPivotVisual = (report, datasets, __) => {
  const primaryDataset = getPrimaryDataset(datasets);
  const {
    columns
  } = report;
  const rowsEncodings = getReportRowsEncodings(report);
  const columnsEncodings = getReportColumnsEncodings(report);
  const valuesEncodings = getReportValuesEncodings(report);
  const isOnlyValues = rowsEncodings.isEmpty() && columnsEncodings.isEmpty();
  const showTotals = report.visual.options.showTotals && !isOnlyValues;
  const showColumnSubtotals = report.visual.options.showColumnSubtotals && rowsEncodings.count() > 1;
  const showRowSubtotals = report.visual.options.showRowSubtotals && columnsEncodings.count() > 1;
  const showRowTotals = valuesEncodings.count() === 1;
  const getTotals = () => {
    const isExclusiveRowsOrColumns = rowsEncodings.isEmpty() || columnsEncodings.isEmpty();
    const measureAliases = valuesEncodings.map(encoding => encoding.column.alias);
    const grandtotals = measureAliases.map(alias => toTotalAlias(alias));
    const getSubtotals = encodings => {
      if (isExclusiveRowsOrColumns) {
        return encodings.isEmpty() ? grandtotals : undefined;
      }
      const dimension = encodings.last().column.alias;
      return measureAliases.map(measure => toSubtotalAlias(dimension, measure));
    };
    const rowSubtotals = getSubtotals(rowsEncodings);
    const columnSubtotals = getSubtotals(columnsEncodings);
    const showUpdatedTotals = !columns.find((_, key) => key.startsWith(SUBTOTAL_ALIAS_PREFIX));
    return {
      rowTotal: showRowTotals ? rowSubtotals : undefined,
      columnTotal: columnSubtotals,
      grandTotal: grandtotals,
      showRowTotal: !!valuesEncodings.count() && showUpdatedTotals && !!rowSubtotals,
      showColumnTotal: !!valuesEncodings.count() && showUpdatedTotals && !!columnSubtotals,
      showRowSubtotals,
      showColumnSubtotals
    };
  };
  const totals = showTotals ? getTotals() : {};
  return CrossTabVisualization(Object.assign({
    type: CROSS_TAB,
    data: {
      primary: primaryDataset
    },
    rows: rowsEncodings.map(encoding => {
      const column = encoding.column;
      const options = encoding.options;
      const field = column.alias;
      return {
        field,
        order: toVisualizationOrder(column, primaryDataset),
        formattingType: options.getIn(['format', 'type']),
        formattingObject: options.get('format')
      };
    }),
    columns: columnsEncodings.map(encoding => {
      const column = encoding.column;
      const options = encoding.options;
      const field = column.alias;
      return {
        field,
        order: toVisualizationOrder(column, primaryDataset),
        formattingType: options.getIn(['format', 'type']),
        formattingObject: options.get('format')
      };
    }),
    values: valuesEncodings.map(encoding => {
      return {
        field: encoding.column.alias,
        formattingType: encoding.options.getIn(['format', 'type']),
        formattingObject: encoding.options.get('format')
      };
    })
  }, totals));
};